import React from 'react';
import { unmeContractColor } from '../../Common/utils/unmeContractColor';

const hasOwn = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
const keyFields = ['contractKey', 'contract_key'];
const nameFields = ['contractName', 'contract_name'];
const sourceFields = ['contractSource', 'contract_source'];
const knownNames = { PRIMARY: '파주', SECONDARY: '서울' };
const normalized = (value) => typeof value === 'string' ? value.trim().toUpperCase() : '';

/** Read the contract attached to this transfer log, never its parent settlement. */
export function unmeCompletedContract(row) {
  if (!row || ![...keyFields, ...nameFields, ...sourceFields].some((key) => hasOwn(row, key))) return null;

  const keys = keyFields.filter((key) => hasOwn(row, key)).map((key) => row[key]);
  const source = normalized(row.contractSource ?? row.contract_source);
  if (source === 'UNRESOLVED' || keys.some((key) => normalized(key) === 'UNMAPPED')) {
    return { label: '계약 정보 확인 필요', key: null, kind: 'review' };
  }
  // Explicit null means that no contract classification applies (e.g. another PG).
  if (keys.some((key) => key === null)) return { label: '-', key: null, kind: 'empty' };

  const presentKeys = keys.filter((key) => key !== undefined && key !== '');
  if (!presentKeys.length) return { label: '-', key: null, kind: 'empty' };
  if (presentKeys.some((key) => typeof key !== 'string')) return { label: '계약 정보 확인 필요', key: null, kind: 'review' };
  const key = normalized(presentKeys[0]);
  if (!knownNames[key] || presentKeys.some((value) => normalized(value) !== key) || (source === 'LEGACY_PRIMARY' && key !== 'PRIMARY')) {
    return { label: '계약 정보 확인 필요', key: null, kind: 'review' };
  }
  if (nameFields.some((field) => hasOwn(row, field) && row[field] === null)) return { label: '-', key: null, kind: 'empty' };
  const rawName = row.contractName ?? row.contract_name;
  const label = typeof rawName === 'string' && rawName.trim() ? rawName.trim() : knownNames[key];
  return { label, key, kind: 'contract' };
}

export default function UnmeCompletedContractBadge({ row }) {
  const contract = unmeCompletedContract(row);
  if (!contract) return null;
  if (contract.kind === 'review') return <span className="inline-block min-w-0 max-w-full whitespace-normal break-all text-[11px] font-semibold text-amber-700">{contract.label}</span>;
  if (contract.kind === 'empty') return <span className="inline-block min-w-0 max-w-full text-[11px] text-slate-500">-</span>;
  return <span className={`inline-block min-w-0 max-w-full whitespace-normal break-all rounded border px-1.5 py-0.5 text-[11px] font-semibold ${unmeContractColor(contract.key)}`}>{contract.label}</span>;
}
